<template>
  <div class="demandReport" id="demandReport">
    <div class="leftDiv">
      <div class="leftTopDiv">
        <div class="userInfoClass">
          <div class="photo">
            <img v-if="userInfo.iconUrl" :src="userInfo.iconUrl" />
          </div>
          <div class="basicInfo">
            <tooltip-over
              :content="userInfo.username"
              :className="'username'"
              class="wid190"
              refName="username"
            ></tooltip-over>
            <div class="line"></div>
            <tooltip-over
              :content="'账号:' + userInfo.userNo"
              :className="'userNo'"
              class="wid190"
              refName="userNo"
            ></tooltip-over>
            <tooltip-over
              :content="userInfo.departmentName"
              :className="'departmentName'"
              class="wid190"
              refName="departmentName"
            ></tooltip-over>
            <tooltip-over
              :content="userInfo.roleName"
              :className="'roleName'"
              class="wid190"
              refName="roleName"
            ></tooltip-over>
          </div>
          <div class="logOut" @click="logOut()"></div>
        </div>
        <div class="statistics">
          <div class="totalTask" :style="opacityOfTotalTask" @click="totalTask">
            <div class="title">任务总数</div>
            <div class="num">{{ taskTotalNum }}</div>
          </div>
          <div
            class="waitApproval"
            :style="opacityOfWaitApproval"
            @click="waitApproval"
          >
            <div class="title">待审批</div>
            <div class="num">{{ waitApprovalNum }}</div>
          </div>
          <div
            class="waitPickUp"
            :style="opacityOfWaitPickUp"
            @click="waitPickUp"
          >
            <div class="title">待取货</div>
            <div class="num">{{ waitPickUpNum }}</div>
          </div>
          <div class="rejected" :style="opacityOfRejected" @click="rejected">
            <div class="title">驳回</div>
            <div class="num">{{ rejectedNum }}</div>
          </div>
        </div>
      </div>
      <div class="leftBottomDiv">
        <div class="contentClass" :style="contentHeight">
          <!-- <div class="title">任务总数</div> -->
          <div>
            <el-table
              ref="taskList"
              :data="taskList"
              @row-click="clickTaskRow"
              :height="tableHeight"
              :row-style="{ height: '40px' }"
              :cell-style="changeCellStyle"
              :row-class-name="tableRowClassName"
              style="width: 92%"
              tooltip-effect="light"
              class="taskTable"
            >
              <el-table-column
                prop="local_id"
                label="任务编号"
                align="center"
                min-width="80"
                :show-overflow-tooltip="true"
              >
              </el-table-column>
              <el-table-column
                prop="mission_name"
                label="任务名称"
                align="center"
                min-width="100"
                :show-overflow-tooltip="true"
              >
              </el-table-column>
              <el-table-column
                prop="priority"
                label="优先级"
                align="center"
                min-width="55"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.priority === 1">低</span>
                  <span v-else-if="scope.row.priority === 2">中</span>
                  <span v-else-if="scope.row.priority === 3">高</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="mission_status"
                label="当前状态"
                min-width="55"
                align="center"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.mission_status === 5">待审批</span>
                  <span v-else-if="scope.row.mission_status === 8">驳回</span>
                  <span v-else-if="scope.row.mission_status === 10"
                    >待取货</span
                  >
                  <span v-else-if="scope.row.mission_status === 20"
                    >完成取货</span
                  >
                  <span v-else-if="scope.row.mission_status === 90"
                    >任务完成</span
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="searchArea">
            <div class="desc">任务搜索</div>
            <div class="separate"></div>
            <el-form :model="queryTaskForm" @submit.native.prevent>
              <el-form-item label="">
                <el-input
                  class="inputClass"
                  v-model="queryTaskForm.mission_name"
                  @keyup.enter.native="queryTask()"
                >
                  <i
                    class="el-icon-search-img"
                    slot="suffix"
                    @click="queryTask()"
                  >
                  </i></el-input
              ></el-form-item>
            </el-form>
          </div>
        </div>
        <div class="buttons" v-if="null !== addPermission">
          <div class="buttonClass" @click="addClick">
            {{ addPermission.name }}
          </div>
          <!-- <div class="exportButton">
            <i class="el-icon-export-img"> </i>导出模板
          </div>
          <div class="importButton">
            <i class="el-icon-import-img"> </i>导入
          </div> -->
        </div>
      </div>
    </div>
    <div class="centerDiv" v-show="clickButton">
      <div class="centerTopDiv" :style="topHeight">
        <div class="formTitle">
          <div class="taskIcon">
            <el-image :src="taskIcon" class="icon" />
          </div>
          <div class="taskInfo">
            <div class="descOfNo">任务编号</div>
            <div class="line"></div>
            <tooltip-over
              :content="taskForm.local_id"
              :className="'taskNo'"
              class="wid190"
              refName="taskNo"
            ></tooltip-over>
          </div>
          <div class="barCodeDiv">
            <img id="barCode" class="barCode" v-show="isDetail" />
          </div>
        </div>
        <div v-show="isDetail">
          <div class="seperate"></div>
          <div class="taskCreateInfo">
            <div class="label">创建时间:</div>
            <div class="content">{{ taskForm.created_at }}</div>
            <div class="label">提交账号:</div>
            <div class="content">{{ taskForm.user_no }}</div>
          </div>
          <div class="seperate"></div>
        </div>
        <div :class="formClass" :style="formHeight">
          <el-form
            ref="taskForm"
            :model="taskForm"
            :rules="taskFormRules"
            @submit.native.prevent
          >
            <div class="firstRow">
              <el-form-item label="任务名称" prop="mission_name">
                <el-input
                  class="formInputClass"
                  placeholder="请填写任务名称(200字内)"
                  maxlength="200"
                  v-model="taskForm.mission_name"
                  :disabled="isDetail && !inWaitPickUp"
                  @keyup.enter.native="submit('taskForm')"
                >
                </el-input
              ></el-form-item>
              <div class="right">
                <el-form-item label="优先级" prop="priority">
                  <div class="priorityDiv">
                    <img
                      :src="minimum"
                      class="minimum"
                      @click="choosePriority(1)"
                    />
                    <div class="prioritySeperate"></div>
                    <img
                      :src="secondary"
                      class="secondary"
                      @click="choosePriority(2)"
                    />
                    <div class="prioritySeperate"></div>
                    <img
                      :src="highest"
                      class="highest"
                      @click="choosePriority(3)"
                    />
                  </div>
                </el-form-item>
              </div>
            </div>
            <div class="row">
              <el-form-item label="预计发货时间" prop="appointment_delivery_at">
                <el-date-picker
                  popper-class="datePickerClass"
                  class="formInputClass"
                  :picker-options="pickerOptions"
                  v-model="taskForm.appointment_delivery_at"
                  type="datetime"
                  placeholder="请选择预计发货时间"
                  :disabled="isDetail && !inWaitPickUp"
                >
                </el-date-picker>
              </el-form-item>
              <div class="right">
                <el-form-item
                  label="预计收货时间"
                  prop="appointment_receive_at"
                >
                  <el-date-picker
                    popper-class="datePickerClass"
                    class="formInputClass"
                    :picker-options="pickerOptions"
                    v-model="taskForm.appointment_receive_at"
                    type="datetime"
                    placeholder="请选择预计收货时间"
                    :disabled="isDetail && !inWaitPickUp"
                  >
                  </el-date-picker>
                </el-form-item>
              </div>
            </div>
            <div class="sendUserInfo" style="background: #0083fd">
              <div class="descOfSendUser">投送信息（发送方）</div>
              <div class="addressInfo">
                <div class="chooseAddress" @click="chooseCustomerAddress(1)">
                  <div class="historyAddress">历史地址</div>
                  <div class="editIcon"></div>
                </div>
                <div
                  :class="customerAddressShowClassName"
                  @click="changeDetailShow(1)"
                ></div>
              </div>
            </div>
            <div class="rowAddress" v-show="customerAddressShow">
              <el-form-item label="补堆名称" prop="customer_company">
                <tooltip-over
                  :content="taskForm.customer_company"
                  :className="'formThreeClass'"
                  :placeholder="'请选择发送地址'"
                  class="wid190"
                  refName="customer_company"
                ></tooltip-over>
                <!-- <el-tooltip
                  class="item"
                  effect="light"
                  :content="taskForm.customer_company"
                  placement="top"
                >
                  <el-input
                    class="formThreeInputClass"
                    ref="customer_company"
                    placeholder="请选择发送地址"
                    v-model="taskForm.customer_company"
                    disabled
                  >
                  </el-input>
                </el-tooltip> -->
              </el-form-item>
              <el-form-item label="联系人" prop="customer_name">
                <tooltip-over
                  :content="taskForm.customer_name"
                  :className="'formThreeClass'"
                  :placeholder="'请选择发送地址'"
                  class="wid190"
                  refName="customer_name"
                ></tooltip-over>
                <!-- <el-tooltip
                  class="item"
                  effect="light"
                  :content="taskForm.customer_name"
                  placement="top"
                >
                  <el-input
                    class="formThreeInputClass"
                    placeholder="请选择发送地址"
                    v-model="taskForm.customer_name"
                    disabled
                  >
                  </el-input> </el-tooltip
              >--></el-form-item
              >
              <div class="right">
                <el-form-item label="联系电话" prop="customer_phone">
                  <tooltip-over
                    :content="taskForm.customer_phone"
                    :className="'formThreeClass'"
                    :placeholder="'请选择发送地址'"
                    class="wid190"
                    refName="customer_phone"
                  ></tooltip-over>
                  <!-- <el-input
                    class="formThreeInputClass"
                    placeholder="请选择发送地址"
                    v-model="taskForm.customer_phone"
                    disabled
                  >
                  </el-input
                > -->
                </el-form-item>
              </div>
            </div>
            <div class="row" v-show="customerAddressShow">
              <el-form-item label="发货战区" prop="station_id">
                <tooltip-over
                  :content="taskForm.station_name"
                  :className="'formTwoClass'"
                  :placeholder="'请选择发送地址'"
                  class="wid190"
                  refName="station_name"
                ></tooltip-over>
                <!-- <el-tooltip
                  class="item"
                  effect="light"
                  :content="taskForm.station_name"
                  placement="top"
                >
                  <el-input
                    class="formInputClass"
                    placeholder="请选择发送地址"
                    v-model="taskForm.station_name"
                    disabled
                  >
                  </el-input>
                </el-tooltip> -->
              </el-form-item>

              <div class="right">
                <el-form-item label="发货地址" prop="customer_address">
                  <tooltip-over
                    :content="taskForm.customer_address"
                    :className="'formTwoClass'"
                    :placeholder="'请选择发送地址'"
                    class="wid190"
                    refName="customer_address"
                  ></tooltip-over>
                  <!-- <el-tooltip
                    class="item"
                    effect="light"
                    :content="taskForm.customer_address"
                    placement="top"
                  >
                    <el-input
                      class="formInputClass"
                      placeholder="请选择发送地址"
                      v-model="taskForm.customer_address"
                      disabled
                    >
                    </el-input> </el-tooltip
                > -->
                </el-form-item>
              </div>
            </div>
            <div class="sendUserInfo" style="background: #ffa63e">
              <div class="descOfSendUser">投送信息（接收方）</div>
              <div class="addressInfo">
                <div class="chooseAddress" @click="chooseCustomerAddress(2)">
                  <div class="historyAddress">历史地址</div>
                  <div class="editIcon"></div>
                </div>
                <div
                  :class="destinationAddressShowClassName"
                  @click="changeDetailShow(2)"
                ></div>
              </div>
            </div>
            <div class="rowAddress" v-show="destinationAddressShow">
              <el-form-item label="补堆名称" prop="destination_company">
                <tooltip-over
                  :content="taskForm.destination_company"
                  :className="'formTwoClass'"
                  :placeholder="'请选择接收地址'"
                  class="wid190"
                  refName="destination_company"
                ></tooltip-over>
                <!-- <el-tooltip
                  class="item"
                  effect="light"
                  :content="taskForm.destination_company"
                  placement="top"
                >
                  <el-input
                    class="formInputClass"
                    placeholder="请选择接收地址"
                    v-model="taskForm.destination_company"
                    disabled
                  >
                  </el-input> </el-tooltip
              > -->
              </el-form-item>
              <div class="right">
                <el-form-item label="收货地址" prop="destination_address">
                  <tooltip-over
                    :content="taskForm.destination_address"
                    :className="'formTwoClass'"
                    :placeholder="'请选择接收地址'"
                    class="wid190"
                    refName="destination_address"
                  ></tooltip-over>
                  <!-- <el-tooltip
                    class="item"
                    effect="light"
                    :content="taskForm.destination_address"
                    placement="top"
                  >
                    <el-input
                      class="formInputClass"
                      placeholder="请选择接收地址"
                      v-model="taskForm.destination_address"
                      disabled
                    >
                    </el-input> </el-tooltip
                > --></el-form-item
                >
              </div>
            </div>
            <div class="row" v-show="destinationAddressShow">
              <el-form-item label="联系人" prop="destination_name">
                <tooltip-over
                  :content="taskForm.destination_name"
                  :className="'formTwoClass'"
                  :placeholder="'请选择接收地址'"
                  class="wid190"
                  refName="destination_name"
                ></tooltip-over>
                <!-- <el-tooltip
                  class="item"
                  effect="light"
                  :content="taskForm.destination_name"
                  placement="top"
                >
                  <el-input
                    class="formInputClass"
                    placeholder="请选择接收地址"
                    v-model="taskForm.destination_name"
                    disabled
                  >
                  </el-input> </el-tooltip> -->
              </el-form-item>
              <div class="right">
                <el-form-item label="联系电话" prop="destination_phone">
                  <tooltip-over
                    :content="taskForm.destination_phone"
                    :className="'formTwoClass'"
                    :placeholder="'请选择接收地址'"
                    class="wid190"
                    refName="destination_phone"
                  ></tooltip-over>
                  <!-- <el-input
                    class="formInputClass"
                    placeholder="请选择接收地址"
                    v-model="taskForm.destination_phone"
                    disabled
                  >
                  </el-input
                > -->
                </el-form-item>
              </div>
            </div>
            <div class="sendUserInfo" style="background: #0083fd">
              <el-checkbox
                v-model="taskForm.needTakeDelivery"
                :disabled="isDetail && !inWaitPickUp"
                class="descOfSendUser"
                @change="changePickUp"
                >是否需要取货</el-checkbox
              >
              <div class="addressInfo" v-show="taskForm.needTakeDelivery">
                <div
                  :class="ifNeedPickUpInfoShowClassName"
                  @click="changeDetailShow(3)"
                ></div>
              </div>
            </div>
            <div class="rowAddress" v-show="ifNeedPickUpInfoShow">
              <el-form-item label="指派货勤">
                <el-select
                  v-model="taskForm.receiver_id"
                  placeholder="请选择指派货勤"
                  @change="changeUser"
                  popper-class="selectPopperClass"
                  :disabled="isDetail && !inWaitPickUp"
                >
                  <el-option
                    v-for="user in users"
                    :key="user.id"
                    :label="user.username"
                    :value="user.id"
                  />
                </el-select>
              </el-form-item>
              <div class="right">
                <el-form-item label="联系电话">
                  <el-input
                    class="formInputClass"
                    placeholder="请选择指派货勤"
                    disabled
                    v-model="taskForm.receiverPhone"
                  >
                  </el-input
                ></el-form-item>
              </div>
            </div>
            <div class="row" v-show="ifNeedPickUpInfoShow">
              <el-form-item label="取货时间" prop="plan_receiver_at">
                <el-date-picker
                  popper-class="datePickerClass"
                  class="formInputClass"
                  :picker-options="pickerOptions"
                  v-model="taskForm.plan_receiver_at"
                  type="datetime"
                  placeholder="请选择取货时间"
                  :disabled="isDetail && !inWaitPickUp"
                >
                </el-date-picker
              ></el-form-item>
            </div>
            <div class="sendUserInfo" style="background: #ffa63e">
              <div class="descOfSendUser">审批员</div>
              <div class="addressInfo">
                <div
                  :class="auditInfoShowClassName"
                  @click="changeDetailShow(4)"
                ></div>
              </div>
            </div>
            <div class="rowAddress" v-show="auditInfoShow">
              <el-form-item label="部门" prop="approve_user_department_id">
                <el-select
                  v-model="taskForm.approve_user_department_id"
                  placeholder="请选择部门"
                  @change="changeDepartment"
                  popper-class="selectPopperClass"
                  :disabled="isDetail && !inWaitPickUp"
                >
                  <el-option
                    v-for="department in departments"
                    :key="department.id"
                    :label="department.name"
                    :value="department.id"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="姓名" prop="approve_user_id">
                <el-select
                  v-model="taskForm.approve_user_id"
                  placeholder="请选择审批员"
                  @change="changeApproveUser"
                  popper-class="selectPopperClass"
                  :disabled="isDetail && !inWaitPickUp"
                >
                  <el-option
                    v-for="user in usersOfApprove"
                    :key="user.id"
                    :label="user.username"
                    :value="user.id"
                  />
                </el-select>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
      <div
        class="centerBottomDiv"
        v-if="
          !isDetail ||
          (isDetail && inWaitPickUp && null !== delPermission) ||
          (isDetail && !inWaitPickUp && null !== copyPermission)
        "
      >
        <div v-if="!isDetail">
          <el-button class="blueButton" @click="concelClick"> 取消</el-button>
        </div>
        <div v-if="isDetail && inWaitPickUp && null !== delPermission">
          <el-button class="deleteButton" @click="deleteClick">
            {{ delPermission.name }}</el-button
          >
        </div>
        <div v-if="isDetail && !inWaitPickUp && null !== copyPermission">
          <el-button class="blueButton" @click="copyClick">
            {{ copyPermission.name }}</el-button
          >
        </div>
      </div>
    </div>
    <div class="rightDiv" v-show="clickButton">
      <div :class="rightTopDiv">
        <el-form
          ref="goodsList"
          :model="goodsForm"
          :rules="goodsFormRule"
          @submit.native.prevent
        >
          <div class="formTitle">
            <div class="taskIcon">
              <el-image :src="goodsIcon" class="goodsIcon" />
            </div>
            <div class="goodsInfo">
              <div class="goodsName">
                <el-form-item label="货物名称" prop="goodsName">
                  <el-input
                    class="goodsNameInput"
                    v-model="goodsForm.goodsName"
                    placeholder="请填写货物名称(50字内)"
                    maxlength="50"
                    :disabled="isDetail && !inWaitPickUp"
                    @keyup.enter.native="submit('taskForm')"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="goodsAttribute" id="goodsAttribute">
            <el-image :src="goodsNumIcon" class="goodsNumIcon" />
            <div class="goodsNum">件数&nbsp;(最多30)</div>
            <el-input-number
              v-model="goodsTotalNum"
              @change="handleGoodsNumChange"
              :min="0"
              :max="30"
              size="mini"
              style="width: 90px"
              label=""
              :disabled="isDetail && !inWaitPickUp"
            ></el-input-number>
            <el-image :src="goodsWeightIcon" class="goodsWeightIcon" />
            <div class="goodsNum">总重量</div>
            <div id="goodsWeight" class="goodsWeight">
              <el-input v-model="goodsTotalWeight" disabled></el-input>
              <div class="unit">Kg</div>
            </div>
          </div>
          <div class="sendUserInfoes">
            <div class="title">货物信息</div>
            <el-table
              ref="goodsList"
              :height="goodsListHeight"
              class="goodsList"
              :data="goodsForm.goodsList"
              :row-style="{ height: '40px' }"
              :cell-style="changeCellStyle"
              :row-class-name="goodsListRowClassName"
            >
              <el-table-column
                label="序号"
                align="center"
                prop="index"
                min-width="60"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                label="货物编号"
                min-width="150"
                align="center"
                prop="local_id"
              >
              </el-table-column>
              <el-table-column
                align="center"
                min-width="330"
                :show-overflow-tooltip="true"
              >
                <template slot="header">
                  <p>
                    <span style="color: #f56c6c; font-size: 16px">*</span>
                    体积（长*宽*高）/cm
                  </p>
                </template>
                <template slot-scope="scope" id="volume" class="volume">
                  <el-form-item
                    :prop="'goodsList.' + scope.$index + '.goods_length'"
                    :rules="goodsFormRule.goods_length"
                  >
                    <el-input-number
                      v-model="scope.row.goods_length"
                      controls-position="right"
                      :min="1"
                      :max="10000"
                      size="mini"
                      style="width: 100px"
                      :disabled="isDetail && !inWaitPickUp"
                      @keyup.enter.native="submit('taskForm')"
                    ></el-input-number>
                  </el-form-item>
                  <el-form-item
                    :prop="'goodsList.' + scope.$index + '.goods_width'"
                    :rules="goodsFormRule.goods_width"
                  >
                    <el-input-number
                      v-model="scope.row.goods_width"
                      controls-position="right"
                      :min="1"
                      :max="10000"
                      size="mini"
                      style="width: 100px"
                      :disabled="isDetail && !inWaitPickUp"
                      @keyup.enter.native="submit('taskForm')"
                    ></el-input-number>
                  </el-form-item>
                  <el-form-item
                    :prop="'goodsList.' + scope.$index + '.goods_height'"
                    :rules="goodsFormRule.goods_height"
                  >
                    <el-input-number
                      v-model="scope.row.goods_height"
                      controls-position="right"
                      :min="1"
                      :max="10000"
                      size="mini"
                      style="width: 100px"
                      :disabled="isDetail && !inWaitPickUp"
                      @keyup.enter.native="submit('taskForm')"
                    ></el-input-number>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="goods_weight"
                min-width="120"
              >
                <template slot="header">
                  <p>
                    <span style="color: #f56c6c; font-size: 16px">*</span>
                    重量/kg
                  </p>
                </template>
                <template slot-scope="scope">
                  <el-form-item
                    :prop="'goodsList.' + scope.$index + '.goods_weight'"
                    :rules="goodsFormRule.goods_weight"
                  >
                    <el-input-number
                      v-model="scope.row.goods_weight"
                      controls-position="right"
                      :min="1"
                      :max="10000"
                      size="mini"
                      style="width: 100px"
                      @change="countTotalWeight"
                      :disabled="isDetail && !inWaitPickUp"
                      @keyup.enter.native="submit('taskForm')"
                    ></el-input-number>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column
                label="属性"
                min-width="280"
                align="center"
                prop="attribute"
              >
                <template slot-scope="scope">
                  <el-checkbox-group
                    v-model="scope.row.attribute"
                    class="attributes"
                    :disabled="isDetail && !inWaitPickUp"
                  >
                    <el-checkbox
                      v-for="(item, index) in attributes"
                      :key="index"
                      :label="item"
                      >{{ item.label }}</el-checkbox
                    >
                  </el-checkbox-group>
                </template>
              </el-table-column>
              <el-table-column
                label="类型"
                min-width="150"
                align="center"
                prop="goods_type_id"
                ><template slot-scope="scope">
                  <el-select
                    v-model="scope.row.goods_type_id"
                    popper-class="selectPopperClass"
                    :disabled="isDetail && !inWaitPickUp"
                  >
                    <el-option
                      v-for="goodsType in goodsTypes"
                      :key="goodsType.id"
                      :label="goodsType.name"
                      :value="goodsType.id"
                    />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                label="包装"
                min-width="150"
                align="center"
                prop="goods_package_id"
                ><template slot-scope="scope">
                  <el-select
                    popper-class="selectPopperClass"
                    v-model="scope.row.goods_package_id"
                    :disabled="isDetail && !inWaitPickUp"
                  >
                    <el-option
                      v-for="goodsPackage in goodsPackages"
                      :key="goodsPackage.id"
                      :label="goodsPackage.name"
                      :value="goodsPackage.id"
                    />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                label="密级"
                min-width="120"
                align="center"
                prop="goods_secrecy_id"
                ><template slot-scope="scope">
                  <el-select
                    popper-class="selectPopperClass"
                    v-model="scope.row.goods_secrecy_id"
                    :disabled="isDetail && !inWaitPickUp"
                  >
                    <el-option
                      v-for="goodsSecrecy in goodsSecrecies"
                      :key="goodsSecrecy.id"
                      :label="goodsSecrecy.name0 + goodsSecrecy.name1"
                      :value="goodsSecrecy.id"
                    />
                  </el-select>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form>
      </div>
      <div class="rightCenterDiv">
        <div class="historyButton">
          <div
            v-if="inWaitPickUp || addTask"
            :class="!isHistory ? 'remarkClassNow' : 'remarkClassHistory'"
            @click="isHistory = false"
          >
            新增备注
          </div>
          <div
            v-if="!addTask"
            :class="isHistory ? 'remarkClassNow' : 'remarkClassHistory'"
            @click="isHistory = true"
          >
            历史备注
          </div>
        </div>
        <div v-if="isHistory">
          <div class="historyRemark">
            <span v-for="(item, index) in taskForm.historyNote" :key="index">
              {{ item }}<br />
            </span>
          </div>
        </div>
        <div v-else-if="inWaitPickUp || addTask">
          <el-input
            style="height: 150px"
            maxlength="500"
            placeholder="请输入备注(500字内，且不能输入$)"
            @input="change($event)"
            type="textarea"
            v-model="taskForm.note"
            :disabled="isDetail && !inWaitPickUp"
          ></el-input>
        </div>
      </div>
      <div
        class="rightBottomDiv"
        v-if="!isDetail || (isDetail && inWaitPickUp)"
      >
        <div v-if="!isDetail">
          <el-button class="editButton" @click="submit('taskForm')">
            提交</el-button
          >
        </div>
        <div v-if="isDetail && inWaitPickUp && null !== editPermission">
          <el-button class="editButton" @click="submit('taskForm')">
            {{ editPermission.name }}</el-button
          >
        </div>
      </div>
    </div>
    <el-dialog
      title=""
      :visible.sync="listDialogVisible"
      :close-on-click-modal="false"
      width="514px"
      id="customerAddress"
      class="addressDialog"
    >
      <div class="addressList">
        <div v-if="isCustomerAddress">
          <el-radio-group
            v-model="customerAddressListForm"
            class="customerAddressData"
          >
            <el-radio
              v-for="(item, index) in customerAddressData"
              :key="index"
              :label="item"
              class="radioClass"
            >
              <div class="rowAddressList">
                <div class="basic">
                  <div class="companyAndName">
                    {{ item.customer_company }}.{{ item.customer_name }}
                  </div>
                  <div class="phone">{{ item.customer_phone }}</div>
                </div>
                <div class="address">
                  {{ item.customer_address }}
                </div>
              </div>
              <div class="iconDiv">
                <i class="el-icon-edit-img" @click="operateAddress(item)"> </i
                ><i class="el-icon-delete-img" @click="delCustomer(item)"> </i>
              </div>
            </el-radio>
          </el-radio-group>
        </div>
        <div v-else>
          <el-radio-group
            v-model="destinationAddressListForm"
            class="customerAddressData"
          >
            <el-radio
              v-for="(item, index) in destinationAddressData"
              :key="index"
              :label="item"
              class="radioClass"
            >
              <div class="rowAddressList">
                <div class="basic">
                  <div class="companyAndName">
                    {{ item.destination_company }}.{{ item.destination_name }}
                  </div>
                  <div class="phone">{{ item.destination_phone }}</div>
                </div>
                <div class="address">
                  {{ item.destination_address }}
                </div>
              </div>
              <div class="iconDiv">
                <i class="el-icon-edit-img" @click="operateAddress(item)"> </i
                ><i class="el-icon-delete-img" @click="delDestination(item)">
                </i>
              </div>
            </el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="formItemBtnRow">
        <el-button type="primary" @click="confirmAddress()" class="confirmBtn"
          >确 定</el-button
        >
        <el-button @click="listDialogVisible = false" class="cancelBtn"
          >取 消</el-button
        >
        <el-button type="primary" @click="operateAddress(false)" class="addBtn"
          >新增地址 <i class="el-icon-add-img"> </i
        ></el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="dialogName"
      :visible.sync="editDialogVisible"
      :close-on-click-modal="false"
      width="318px"
      id="customerAddress"
      :class="dialogClassName"
    >
      <div v-if="isCustomerAddress">
        <el-form
          ref="customerAddressForm"
          class="formAddress"
          :model="customerAddressForm"
          :rules="customerAddressRules"
          @submit.native.prevent
        >
          <el-form-item label="补堆名称" prop="customer_company">
            <el-input
              v-model="customerAddressForm.customer_company"
              placeholder="200字内"
              maxlength="200"
              class="inputAClass"
              @keyup.enter.native="saveAddress()"
            ></el-input>
          </el-form-item>
          <!-- <div class="line"></div> -->
          <el-form-item
            label="联 系 人"
            prop="customer_name"
            class="addressFormItem"
          >
            <el-input
              v-model="customerAddressForm.customer_name"
              maxlength="50"
              placeholder="50字内"
              class="inputAClass"
              @keyup.enter.native="saveAddress()"
            ></el-input>
          </el-form-item>
          <!-- <div class="line"></div> -->
          <el-form-item
            label="联系电话"
            prop="customer_phone"
            class="addressFormItem"
          >
            <el-input
              v-model="customerAddressForm.customer_phone"
              maxlength="20"
              placeholder="20字内"
              class="inputAClass"
              @keyup.enter.native="saveAddress()"
            ></el-input>
          </el-form-item>
          <!-- <div class="line"></div> -->
          <el-form-item
            label="发货战区"
            prop="station_id"
            class="addressFormItem"
          >
            <el-cascader
              popper-class="cascaderClass"
              class="formAddressInputClass"
              placeholder="请选择发货战区"
              v-model="customerAddressForm.station_id"
              :options="stations"
              :props="{
                expandTrigger: 'hover',
                value: 'id',
                label: 'value',
              }"
              @change="handleAddressChange"
            >
              <template slot-scope="{ data }">
                <span class="stations">{{ data.value }}</span>
              </template>
            </el-cascader>
          </el-form-item>
          <!-- <div class="line"></div> -->
          <el-form-item
            label="发货地址"
            prop="customer_address"
            class="addressFormItem"
          >
            <el-input
              v-model="customerAddressForm.customer_address"
              type="textarea"
              placeholder="500字内"
              @keyup.enter.native="saveAddress()"
            ></el-input>
          </el-form-item>
          <!-- <div class="line"></div> -->
          <el-form-item
            label="设置默认地址"
            prop="is_default"
            class="addressIfDefaultFormItem"
            ><el-switch
              v-model="customerAddressForm.is_default"
              active-value="1"
              active-color="rgba(255, 166, 62, 1)"
              inactive-color="rgba(193, 193, 193, 1)"
              inactive-value="0"
            >
            </el-switch>
          </el-form-item>
        </el-form>
      </div>
      <div v-else>
        <el-form
          class="formAddress"
          ref="destinationAddressForm"
          :model="destinationAddressForm"
          :rules="destinationAddressRules"
          @submit.native.prevent
        >
          <el-form-item label="补堆名称" prop="destination_company">
            <el-input
              v-model="destinationAddressForm.destination_company"
              maxlength="200"
              placeholder="200字内"
              class="inputAClass"
              @keyup.enter.native="saveAddress()"
            ></el-input>
          </el-form-item>
          <!-- <div class="line"></div> -->
          <el-form-item
            label="联 系 人"
            prop="destination_name"
            class="addressFormItem"
          >
            <el-input
              v-model="destinationAddressForm.destination_name"
              maxlength="50"
              placeholder="50字内"
              class="inputAClass"
              @keyup.enter.native="saveAddress()"
            ></el-input>
          </el-form-item>
          <!-- <div class="line"></div> -->
          <el-form-item
            label="联系电话"
            prop="destination_phone"
            class="addressFormItem"
          >
            <el-input
              v-model="destinationAddressForm.destination_phone"
              maxlength="20"
              class="inputAClass"
              placeholder="20字内"
              @keyup.enter.native="saveAddress()"
            ></el-input>
          </el-form-item>
          <!-- <div class="line"></div> -->
          <el-form-item
            label="收货地址"
            prop="destination_address"
            class="addressFormItem"
          >
            <el-input
              v-model="destinationAddressForm.destination_address"
              maxlength="500"
              type="textarea"
              placeholder="500字内"
              @keyup.enter.native="saveAddress()"
            ></el-input>
          </el-form-item>
          <!-- <div class="line"></div> -->
          <el-form-item
            label="设置默认地址"
            prop="is_default"
            class="addressIfDefaultFormItem"
            ><el-switch
              v-model="destinationAddressForm.is_default"
              active-value="1"
              active-color="rgba(255, 166, 62, 1)"
              inactive-color="rgba(193, 193, 193, 1)"
              inactive-value="0"
            >
            </el-switch>
          </el-form-item>
        </el-form>
      </div>
      <div class="formItemBtn">
        <el-button type="primary" @click="saveAddress()" class="confirmBtn"
          >保存并使用</el-button
        >
        <el-button @click="editDialogVisible = false" class="cancelBtn"
          >取 消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/javascript">
import taskIcon from "../../assets/img/home/task.png";
import goodsIcon from "../../assets/img/home/goods.png";
import goodsNumIcon from "../../assets/img/home/goodsNum.png";
import goodsWeightIcon from "../../assets/img/home/goodsWeight.png";
import minimum from "../../assets/img/home/minimum.png";
import minimumUnchecked from "../../assets/img/home/minimumUnchecked.png";
import secondary from "../../assets/img/home/secondary.png";
import secondaryUnchecked from "../../assets/img/home/secondaryUnchecked.png";
import highest from "../../assets/img/home/highest.png";
import highestUnchecked from "../../assets/img/home/highestUnchecked.png";
import JsBarcode from "jsbarcode";
import tooltipOver from "../tools/tooltipOver";
export default {
  name: "DemandReport",
  props: ["userInfo", "menuId"],
  data() {
    let checkPhone = (rule, value, callback) => {
      if (value) {
        let regPhone = /^(13[0-9]|14[01456879]|15[0-3,5-9]|16[2567]|17[0-8]|18[0-9]|19[0-3,5-9])\d{8}$/; //11位手机号码正则
        if (!regPhone.test(value)) {
          regPhone = /0\d{2,3}-\d{7,8}(-\d{1,6})?/; //座机号码
          if (!regPhone.test(value)) {
            callback(new Error("联系电话格式不正确~"));
          } else {
            callback();
          }
        } else {
          callback();
        }
      } else {
        callback(new Error("请填写联系电话~"));
      }
    };
    //预计发货时间
    let validateDelivery = (rule, value, callback) => {
      if (this.taskForm.id) {
        callback();
      } else {
        if (value) {
          value = new Date(value);
          if (value.getTime() < Date.now()) {
            callback(new Error("预计发货时间不能早于当前时间~"));
          } else {
            let appointment_receive_at = this.taskForm.appointment_receive_at;
            if (appointment_receive_at) {
              appointment_receive_at = new Date(appointment_receive_at);
              if (value > appointment_receive_at) {
                callback(new Error("预计发货时间不能晚于预计收货时间~"));
              } else {
                if (this.taskForm.plan_receiver_at) {
                  this.$refs.taskForm.validateField("plan_receiver_at");
                }
                callback();
              }
            } else {
              if (this.taskForm.plan_receiver_at) {
                this.$refs.taskForm.validateField("plan_receiver_at");
              }
              callback();
            }
          }
        } else {
          callback(new Error("请选择预计发货时间~"));
        }
      }
    };
    // 预计收货时间
    let validateReceive = (rule, value, callback) => {
      if (value) {
        value = new Date(value);
        let appointment_delivery_at = this.taskForm.appointment_delivery_at;
        if (appointment_delivery_at) {
          appointment_delivery_at = new Date(appointment_delivery_at);
          if (value < appointment_delivery_at) {
            callback(new Error("预计收货时间不能早于预计发货时间~"));
          } else {
            if (this.taskForm.plan_receiver_at) {
              this.$refs.taskForm.validateField("plan_receiver_at");
            }
            callback();
          }
        } else {
          if (this.taskForm.plan_receiver_at) {
            this.$refs.taskForm.validateField("plan_receiver_at");
          }
          callback();
        }
      } else {
        callback(new Error("请选择预计收货时间~"));
      }
    };
    // 取货时间
    let validatePlanReceive = (rule, value, callback) => {
      if (value) {
        value = new Date(value);
        let appointment_delivery_at = this.taskForm.appointment_delivery_at;
        let appointment_receive_at = this.taskForm.appointment_receive_at;
        if (appointment_delivery_at && appointment_receive_at) {
          appointment_delivery_at = new Date(appointment_delivery_at);
          appointment_receive_at = new Date(appointment_receive_at);
          if (
            value < appointment_delivery_at ||
            value > appointment_receive_at
          ) {
            callback(new Error("需在预计收货时间和预计发货时间区间~"));
          } else {
            callback();
          }
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        },
      },
      clickButton: false,
      rightTopDiv: "rightTopDiv",
      goodsListHeight: 281,
      taskTotalNum: 0,
      waitApprovalNum: 0,
      waitPickUpNum: 0,
      rejectedNum: 0,
      opacityOfTotalTask: "opacity: 1;",
      opacityOfWaitApproval: "opacity: 0.4;",
      opacityOfWaitPickUp: "opacity: 0.4;",
      opacityOfRejected: "opacity: 0.4;",
      openTab: "totalTask",

      minimum: minimumUnchecked,
      secondary: secondaryUnchecked,
      highest: highestUnchecked,
      taskIcon: taskIcon,
      goodsIcon: goodsIcon,
      goodsNumIcon: goodsNumIcon,
      goodsWeightIcon: goodsWeightIcon,
      roleName: "地面保障员",
      queryTaskForm: {
        mission_name: "",
        priority: "",
        mission_status: "",
        is_removed: 0,
        currentpage: 1,
        pagesize: 0,
      },
      taskList: [],
      openedId: null, //已展开的任务
      taskForm: {
        id: "",
        local_id: "0000000-0000",
        user_no: "",
        mission_name: "",
        priority: "",
        customer_company: "",
        customer_name: "",
        customer_phone: "",
        customer_address: "",
        area_id: "",
        station_id: "",
        station_name: "",

        destination_company: "",
        destination_name: "",
        destination_phone: "",
        destination_address: "",

        appointment_delivery_at: "",
        appointment_receive_at: "",
        needTakeDelivery: false,
        need_take_delivery: "0",

        receiver_id: "",
        receiverPhone: "",

        approve_user_department_id: "",
        approve_user_id: "",

        plan_receiver_at: "",
        mission_status: "",
        historyNote: "",
        note: "",
        user_id: "",
        created_at: "",
        is_removed: 0,
      },
      isHistory: false,
      addTask: true,
      // 表单验证
      taskFormRules: {
        mission_name: [
          { required: true, message: "请填写任务名称~", trigger: "blur" },
        ],
        appointment_delivery_at: [
          {
            required: true,
            validator: validateDelivery,
            trigger: "change",
          },
        ],
        appointment_receive_at: [
          {
            required: true,
            validator: validateReceive,
            trigger: "change",
          },
        ],
        plan_receiver_at: [
          {
            required: false,
            validator: validatePlanReceive,
            trigger: "change",
          },
        ],
        priority: [
          {
            required: true,
            message: "请选择任务优先级~",
            trigger: "change",
          },
        ],
        customer_company: [
          { required: true, message: "请选择发货地址信息~", trigger: "blur" },
        ],
        customer_address: [
          { required: true, message: "请选择发货地址信息~", trigger: "blur" },
        ],
        station_id: [
          { required: true, message: "请选择发货地址信息~", trigger: "blur" },
        ],
        customer_name: [
          { required: true, message: "请选择发货地址信息~", trigger: "blur" },
        ],
        customer_phone: [
          { required: true, message: "请选择发货地址信息~", trigger: "blur" },
        ],
        destination_company: [
          { required: true, message: "请选择收货地址信息~", trigger: "blur" },
        ],
        destination_address: [
          { required: true, message: "请选择收货地址信息~", trigger: "blur" },
        ],
        destination_name: [
          { required: true, message: "请选择收货地址信息~", trigger: "blur" },
        ],
        destination_phone: [
          { required: true, message: "请选择收货地址信息~", trigger: "blur" },
        ],
        approve_user_department_id: [
          { required: true, message: "请选择部门~", trigger: "change" },
        ],
        approve_user_id: [
          { required: true, message: "请选择审核员~", trigger: "change" },
        ],
      },
      goodsTotalNum: 0,
      goodsNum: 0,
      // 货物总重量
      goodsTotalWeight: 0,
      // 货物名称
      goodsName: "",
      // 货物列表
      goodsList: [],
      goodsForm: {
        goodsName: "",
        goodsList: [],
      },
      goodsFormRule: {
        goodsName: [
          { required: true, message: "请填写货物名称~", trigger: "blur" },
        ],
        goods_length: [
          { required: true, message: "请填写货物长度~", trigger: "blur" },
        ],
        goods_width: [
          { required: true, message: "请填写货物宽度~", trigger: "blur" },
        ],
        goods_height: [
          { required: true, message: "请填写货物高度~", trigger: "blur" },
        ],
        goods_weight: [
          { required: true, message: "请填写货物重量~", trigger: "blur" },
        ],
      },
      multipleSelection: [],
      customerAddressShowClassName: "downArrow",
      customerAddressShow: true,
      destinationAddressShowClassName: "downArrow",
      destinationAddressShow: true,
      ifNeedPickUpInfoShowClassName: "downArrow",
      ifNeedPickUpInfoShow: true,

      auditInfoShowClassName: "downArrow",
      auditInfoShow: true,

      listDialogVisible: false,
      editDialogVisible: false,
      dialogName: "新增发货地址信息",
      dialogClassName: "sendAddressViewDialog",
      // 是否为收货地址
      isCustomerAddress: true,
      // 发货地址列表
      customerAddressData: [],
      customerAddressListForm: {},
      // 发货地址表单
      customerAddressForm: {
        id: "",
        customer_company: "",
        customer_name: "",
        customer_phone: "",
        customer_address: "",
        area_id: "",
        area_name: "",
        station_id: "",
        station_name: "",
        is_default: "1",
      },
      // 发货地址表单校验
      customerAddressRules: {
        customer_company: [
          {
            required: true,
            message: "请填写补堆名称~",
            trigger: "blur",
          },
        ],
        customer_name: [
          {
            required: true,
            message: "请填写联 系 人~",
            trigger: "blur",
          },
        ],
        customer_phone: [
          { required: true, validator: checkPhone, trigger: "blur" },
        ],
        customer_address: [
          {
            required: true,
            message: "请填写发货地址~",
            trigger: "blur",
          },
        ],
        station_id: [
          {
            required: true,
            message: "请选择发货战区~",
            trigger: "change",
          },
        ],
      },
      // 收货地址列表
      destinationAddressData: [],
      destinationAddressListForm: {},
      // 收货地址表单
      destinationAddressForm: {
        id: "",
        destination_company: "",
        destination_name: "",
        destination_phone: "",
        destination_address: "",
        is_default: "1",
      },
      // 收货地址表单校验
      destinationAddressRules: {
        destination_company: [
          {
            required: true,
            message: "请填写补堆名称~",
            trigger: "blur",
          },
        ],
        destination_name: [
          {
            required: true,
            message: "请填写联 系 人~",
            trigger: "blur",
          },
        ],
        destination_phone: [
          { required: true, validator: checkPhone, trigger: "blur" },
        ],
        destination_address: [
          {
            required: true,
            message: "请填写收货地址~",
            trigger: "blur",
          },
        ],
      },
      // 任务表单class属性
      formClass: "form",
      // 是否是查看详情
      isDetail: false,
      // 是否是待取货状态
      inWaitPickUp: false,
      // 属性
      attributes: [
        {
          id: "0",
          label: "易碎性",
        },
        {
          id: "1",
          label: "易爆性",
        },
        {
          id: "2",
          label: "易燃性",
        },
        {
          id: "3",
          label: "腐蚀性",
        },
      ],
      // 类型
      goodsTypes: [],
      // 包装
      goodsPackages: [],
      // 密级
      goodsSecrecies: [
        {
          id: 0,
          name0: "非",
          name1: "密",
        },
        {
          id: 1,
          name0: "秘",
          name1: "密",
        },
        {
          id: 2,
          name0: "机",
          name1: "密",
        },
        {
          id: 3,
          name0: "绝",
          name1: "密",
        },
      ],
      stations: [], //战区
      users: [], //用户
      departments: [], //部门
      roleNameOfApprove: "态势监控员", //审批员角色名称
      usersOfApprove: [], //审批员
      contentHeight: " height: 395px",
      topHeight: "height: 720px;",
      formHeight: "height: 528px;",
      tableHeight: 325,
      addPermission: null, //添加任务权限
      copyPermission: null, //复制任务权限
      editPermission: null, //修改权限
      delPermission: null, //删除权限

      replaceStr: "$", //分隔符
    };
  },
  components: {
    "tooltip-over": tooltipOver,
  },
  methods: {
    change(e) {
      this.$forceUpdate();
      // 限制输入特殊字符$
      this.taskForm.note = e.replace(this.replaceStr, "");
    },
    showMore(val) {
      this.$confirm(val, "", {
        confirmButtonText: "好的",
        customClass: "confirmClass-style",
        iconClass: "",
        confirmButtonClass: "confirm",
        showCancelButton: false,
      });
    },
    totalTask() {
      if (this.openTab !== "totalTask") {
        this.opacityOfTotalTask = "opacity: 1;";
        this.opacityOfWaitApproval = "opacity: 0.4;";
        this.opacityOfWaitPickUp = "opacity: 0.4;";
        this.opacityOfRejected = "opacity: 0.4;";
        this.openedId = null;
        this.clickButton = false;
        this.queryTaskForm.mission_status = "";
        this.queryTask();
      }
      this.openTab = "totalTask";
    },
    waitApproval() {
      if (this.openTab !== "waitApproval") {
        this.opacityOfTotalTask = "opacity: 0.4;";
        this.opacityOfWaitApproval = "opacity: 1;";
        this.opacityOfWaitPickUp = "opacity: 0.4;";
        this.opacityOfRejected = "opacity: 0.4;";
        this.openedId = null;
        this.clickButton = false;
        this.queryTaskForm.mission_status = 5;
        this.queryTask();
      }
      this.openTab = "waitApproval";
    },
    waitPickUp() {
      if (this.openTab !== "waitPickUp") {
        this.opacityOfTotalTask = "opacity: 0.4;";
        this.opacityOfWaitApproval = "opacity: 0.4;";
        this.opacityOfWaitPickUp = "opacity: 1;";
        this.opacityOfRejected = "opacity: 0.4;";
        this.openedId = null;
        this.clickButton = false;
        this.queryTaskForm.mission_status = 10;
        this.queryTask();
      }
      this.openTab = "waitPickUp";
    },
    rejected() {
      if (this.openTab !== "rejected") {
        this.opacityOfTotalTask = "opacity: 0.4;";
        this.opacityOfWaitApproval = "opacity: 0.4;";
        this.opacityOfWaitPickUp = "opacity: 0.4;";
        this.opacityOfRejected = "opacity: 1;";
        this.openedId = null;
        this.clickButton = false;
        this.queryTaskForm.mission_status = 8;
        this.queryTask();
      }
      this.openTab = "rejected";
    },
    // 获取今日提交任务数，总任务数，待取货任务数
    getMissionStatisics() {
      this.getRequest("/uav-task-server/mission/getMissionStatisics.do").then(
        (res) => {
          let oData = res.data;
          if (oData.code == 0) {
            let data = oData.data;
            if (data) {
              this.taskTotalNum = data.totalmission;
              this.waitApprovalNum = data.waitingForApprove;
              this.waitPickUpNum = data.waitingForDelivery;
              this.rejectedNum = data.reject;
            } else {
              this.taskTotalNum = 0;
              this.waitApprovalNum = 0;
              this.waitPickUpNum = 0;
              this.rejectedNum = 0;
            }
          } else if (oData.code != 401) {
            let msg = "<i class='el-icon-warn-tip'></i>啊哦,任务统计获取失败~";
            this.$confirm(msg, "提示", {
              confirmButtonText: "好的",
              customClass: "confirmClass-style",
              iconClass: "",
              confirmButtonClass: "confirm",
              dangerouslyUseHTMLString: true,
              showCancelButton: false,
            });
          }
        }
      );
    },
    changePickUp() {
      let needTakeDelivery = this.taskForm.needTakeDelivery;
      if (!needTakeDelivery) {
        this.ifNeedPickUpInfoShow = false;
      } else {
        this.ifNeedPickUpInfoShow = true;
      }
      if (this.ifNeedPickUpInfoShow) {
        this.ifNeedPickUpInfoShowClassName = "downArrow";
      } else {
        this.ifNeedPickUpInfoShowClassName = "downArrowAfter";
      }
    },
    changeDetailShow(val) {
      if (1 === val) {
        this.customerAddressShow = !this.customerAddressShow;
        if (this.customerAddressShow) {
          this.customerAddressShowClassName = "downArrow";
        } else {
          this.customerAddressShowClassName = "downArrowAfter";
        }
      } else if (2 === val) {
        this.destinationAddressShow = !this.destinationAddressShow;
        if (this.destinationAddressShow) {
          this.destinationAddressShowClassName = "downArrow";
        } else {
          this.destinationAddressShowClassName = "downArrowAfter";
        }
      } else if (3 === val) {
        this.ifNeedPickUpInfoShow = !this.ifNeedPickUpInfoShow;
        if (this.ifNeedPickUpInfoShow) {
          this.ifNeedPickUpInfoShowClassName = "downArrow";
        } else {
          this.ifNeedPickUpInfoShowClassName = "downArrowAfter";
        }
      } else if (4 === val) {
        this.auditInfoShow = !this.auditInfoShow;
        if (this.auditInfoShow) {
          this.auditInfoShowClassName = "downArrow";
        } else {
          this.auditInfoShowClassName = "downArrowAfter";
        }
      }
    },
    // 获取部门信息
    queryDepartment() {
      this.postJsonRequest("/user-server/api/u-department/query?size=-1", {removed: 0})
        .then((res) => {
          res = res.data;
          if (null != res && !this.isEmptyArray(res.data.records)) {
            if (null != res.data) {
              this.departments = res.data.records;
            } else {
              this.departments = [];
            }
          } else if (res.code != 401) {
            let msg = "请求数据失败";
            if (!this.isEmptyStr(res.msg)) {
              msg = res.msg;
            }
            // this.confirmMessage(false, msg);
          }
        })
        .catch((error) => {});
    },
    // 更换部门信息
    changeDepartment() {
      this.$set(this.taskForm, "approve_user_id", "");
      if (this.taskForm.approve_user_department_id) {
        this.getUsers(
          2,
          this.roleNameOfApprove,
          this.taskForm.approve_user_department_id
        );
      } else {
        this.usersOfApprove = [];
      }
    },
    // 选择审核员
    changeApproveUser() {
      let approve_user_department_id = this.taskForm.approve_user_department_id;
      if (!approve_user_department_id) {
        this.taskForm.approve_user_id = "";
        let tips = "<i class='el-icon-warn-tip'></i>要先选择部门,才能选择人员~";
        this.$confirm(tips, "提示", {
          confirmButtonText: "好的",
          customClass: "confirmClass-style",
          iconClass: "",
          confirmButtonClass: "confirm",
          dangerouslyUseHTMLString: true,
          showCancelButton: false,
        });
      }
    },
    chooseCustomerAddress(val) {
      if (this.isDetail && !this.inWaitPickUp) {
      } else {
        this.listDialogVisible = true;
        if (1 === val) {
          this.isCustomerAddress = true;
          this.$nextTick(() => {
            this.getCustomerList();
          });
        } else if (2 === val) {
          this.isCustomerAddress = false;
          this.$nextTick(() => {
            this.getDestinationList();
          });
        }
      }
    },
    confirmAddress() {
      this.listDialogVisible = false;
      if (this.isCustomerAddress) {
        this.customerAddressForm = this.customerAddressListForm;
        this.setCustomerAddressForm();
      } else {
        this.destinationAddressForm = this.destinationAddressListForm;
        this.setDestinationAddressForm();
      }
    },
    operateAddress(item) {
      this.editDialogVisible = true;
      let isCustomerAddress = this.isCustomerAddress;
      if (item) {
        if (isCustomerAddress) {
          this.dialogName = "编辑发货地址信息";
          this.dialogClassName = "sendAddressViewDialog";
          this.customerAddressForm = item;
          if (this.customerAddressForm.is_default) {
            this.customerAddressForm.is_default = String(
              this.customerAddressForm.is_default
            );
          }
          if (this.$refs.customerAddressForm) {
            this.$refs.customerAddressForm.clearValidate();
          }
        } else {
          this.dialogName = "编辑收货地址信息";
          this.dialogClassName = "reciAddressViewDialog";
          this.destinationAddressForm = item;
          if (this.destinationAddressForm.is_default) {
            this.destinationAddressForm.is_default = String(
              this.destinationAddressForm.is_default
            );
          }
          if (this.$refs.destinationAddressForm) {
            this.$refs.destinationAddressForm.clearValidate();
          }
        }
      } else {
        if (isCustomerAddress) {
          this.customerAddressForm = {
            id: "",
            customer_company: "",
            customer_name: "",
            customer_phone: "",
            customer_address: "",
            area_id: "",
            area_name: "",
            station_id: "",
            station_name: "",
            is_default: "1",
          };
          this.dialogName = "新增发货地址信息";
          this.dialogClassName = "sendAddressViewDialog";
          if (this.$refs.customerAddressForm) {
            this.$refs.customerAddressForm.clearValidate();
          }
        } else {
          this.destinationAddressForm = {
            id: "",
            destination_company: "",
            destination_name: "",
            destination_phone: "",
            destination_address: "",
            is_default: "1",
          };
          this.dialogName = "新增收货地址信息";
          this.dialogClassName = "reciAddressViewDialog";
          if (this.$refs.destinationAddressForm) {
            this.$refs.destinationAddressForm.clearValidate();
          }
        }
      }
      this.$nextTick(() => {
        this.initCascaderStyle();
      });
    },
    saveAddress() {
      let isCustomerAddress = this.isCustomerAddress;
      let formName = "destinationAddressForm";
      if (isCustomerAddress) {
        formName = "customerAddressForm";
      }
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (isCustomerAddress) {
            if (this.customerAddressForm.id) {
              this.updateCustomer();
            } else {
              this.addCustomer();
            }
          } else {
            if (this.destinationAddressForm.id) {
              this.updateDestination();
            } else {
              this.addDestination();
            }
          }
        }
      });
    },
    // 新增发货地址
    addCustomer() {
      this.postJsonRequest(
        "/uav-task-server/customer/addCustomer.do",
        this.customerAddressForm
      ).then((res) => {
        let oData = res.data;
        if (oData.code === 0) {
          this.listDialogVisible = false;
          this.editDialogVisible = false;
          this.setCustomerAddressForm();
        } else if (oData.code != 401) {
          let msg = "<i class='el-icon-warn-tip'></i>" + oData.msg;
          this.$confirm(msg, "提示", {
            confirmButtonText: "好的",
            customClass: "confirmClass-style",
            iconClass: "",
            confirmButtonClass: "confirm",
            dangerouslyUseHTMLString: true,
            showCancelButton: false,
          });
        }
      });
    },
    // 获取发货地址列表
    getCustomerList() {
      this.getRequest(
        "/uav-task-server/customer/getCustomerList.do?currentpage=1&pagesize=0"
      ).then((res) => {
        let oData = res.data;
        if (oData.code == 0) {
          let data = oData.data;
          if (data) {
            let list = data.list;
            this.customerAddressData = list;
            if (list && list.length > 0) {
              this.customerAddressListForm = list[0];
            }
          }
        } else if (oData.code != 401) {
          let tips = "<i class='el-icon-warn-tip'></i>啊哦,发货地址获取失败~";
          this.$confirm(tips, "提示", {
            confirmButtonText: "好的",
            customClass: "confirmClass-style",
            iconClass: "",
            confirmButtonClass: "confirm",
            dangerouslyUseHTMLString: true,
            showCancelButton: false,
          });
        }
      });
    },
    // 删除发货地址信息
    delCustomer(item) {
      let tips = "<i class='el-icon-warn-tip'></i>确定删除该地址信息?";
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "confirmClass-style",
        iconClass: "",
        confirmButtonClass: "confirm",
        dangerouslyUseHTMLString: true,
        cancelButtonClass: "cancel",
      })
        .then(() => {
          this.postJsonRequest(
            "/uav-task-server/customer/delCustomer.do",
            item
          ).then((res) => {
            let oData = res.data;
            if (oData.code === 0) {
              this.getCustomerList();
            } else if (oData.code != 401) {
              let tips = "<i class='el-icon-warn-tip'></i>" + oData.msg;
              this.$confirm(tips, "提示", {
                confirmButtonText: "好的",
                customClass: "confirmClass-style",
                iconClass: "",
                confirmButtonClass: "confirm",
                dangerouslyUseHTMLString: true,
                showCancelButton: false,
              });
            }
          });
        })
        .catch((err) => {
        });
    },
    // 修改发货地址
    updateCustomer() {
      this.postJsonRequest(
        "/uav-task-server/customer/updateCustomer.do",
        this.customerAddressForm
      ).then((res) => {
        let oData = res.data;
        if (oData.code === 0) {
          this.listDialogVisible = false;
          this.editDialogVisible = false;
          this.setCustomerAddressForm();
        } else if (oData.code != 401) {
          let tips = "<i class='el-icon-warn-tip'></i>" + oData.msg;
          this.$confirm(tips, "提示", {
            confirmButtonText: "好的",
            customClass: "confirmClass-style",
            iconClass: "",
            confirmButtonClass: "confirm",
            dangerouslyUseHTMLString: true,
            showCancelButton: false,
          });
        }
      });
    },
    // 设置发货战区
    setStationAndArea(area_id, station_id) {
      if (area_id && station_id) {
        let area_name = "";
        let station_name = "";
        let stations = this.stations;
        if (stations && stations.length > 0) {
          for (let i = 0, len = stations.length; i < len; i++) {
            let station = stations[i];
            if (station && area_id === station.id) {
              area_name = station.value;
              let children = station.children;
              if (children && children.length > 0) {
                for (let j = 0, lenC = children.length; j < lenC; j++) {
                  let child = children[j];
                  if (child && station_id === child.id) {
                    station_name = child.value;
                    break;
                  }
                }
              }
              break;
            }
          }
        }
        this.taskForm.station_name = area_name + "/" + station_name;
      } else {
        this.taskForm.station_name = "";
      }
    },
    // 设置任务发货地址
    setCustomerAddressForm() {
      this.taskForm.customer_company = this.customerAddressForm.customer_company;
      this.taskForm.customer_name = this.customerAddressForm.customer_name;
      this.taskForm.customer_phone = this.customerAddressForm.customer_phone;
      this.taskForm.customer_address = this.customerAddressForm.customer_address;
      this.taskForm.area_id = this.customerAddressForm.area_id;
      this.taskForm.station_id = this.customerAddressForm.station_id;
      let area_id = this.customerAddressForm.area_id;
      let station_id = this.customerAddressForm.station_id;
      this.setStationAndArea(area_id, station_id);
      this.$refs.taskForm.validateField("customer_company");
      this.$refs.taskForm.validateField("customer_name");
      this.$refs.taskForm.validateField("customer_phone");
      this.$refs.taskForm.validateField("customer_address");
      this.$refs.taskForm.validateField("area_id");
      this.$refs.taskForm.validateField("station_id");
    },
    // 新增收货地址
    addDestination() {
      this.postJsonRequest(
        "/uav-task-server/customer/addDestination.do",
        this.destinationAddressForm
      ).then((res) => {
        let oData = res.data;
        if (oData.code === 0) {
          this.listDialogVisible = false;
          this.editDialogVisible = false;
          this.setDestinationAddressForm();
        } else if (oData.code != 401) {
          let tips = "<i class='el-icon-warn-tip'></i>" + oData.msg;
          this.$confirm(tips, "提示", {
            confirmButtonText: "好的",
            customClass: "confirmClass-style",
            iconClass: "",
            confirmButtonClass: "confirm",
            dangerouslyUseHTMLString: true,
            showCancelButton: false,
          });
        }
      });
    },
    // 获取收货地址列表
    getDestinationList() {
      this.getRequest(
        "/uav-task-server/customer/getDestinationList.do?currentpage=1&pagesize=0"
      ).then((res) => {
        let oData = res.data;
        if (oData.code == 0) {
          let data = oData.data;
          if (data) {
            let list = data.list;
            this.destinationAddressData = list;
            if (list && list.length > 0) {
              this.destinationAddressListForm = list[0];
            }
          }
        } else if (oData.code != 401) {
          let tips = "<i class='el-icon-warn-tip'></i>啊哦,收货地址获取失败~";
          this.$confirm(tips, "提示", {
            confirmButtonText: "好的",
            customClass: "confirmClass-style",
            iconClass: "",
            confirmButtonClass: "confirm",
            dangerouslyUseHTMLString: true,
            showCancelButton: false,
          });
        }
      });
    },
    // 删除收货地址信息
    delDestination(item) {
      let tips = "<i class='el-icon-warn-tip'></i>确定删除该地址信息?";
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "confirmClass-style",
        iconClass: "",
        confirmButtonClass: "confirm",
        dangerouslyUseHTMLString: true,
        cancelButtonClass: "cancel",
      })
        .then(() => {
          this.postJsonRequest(
            "/uav-task-server/customer/delDestination.do",
            item
          ).then((res) => {
            let oData = res.data;
            if (oData.code === 0) {
              this.getDestinationList();
            } else if (oData.code != 401) {
              let tips = "<i class='el-icon-warn-tip'></i>" + oData.msg;
              this.$confirm(tips, "提示", {
                confirmButtonText: "好的",
                customClass: "confirmClass-style",
                iconClass: "",
                confirmButtonClass: "confirm",
                dangerouslyUseHTMLString: true,
                showCancelButton: false,
              });
            }
          });
        })
        .catch((err) => {
        });
    },
    // 修改收货地址
    updateDestination() {
      this.postJsonRequest(
        "/uav-task-server/customer/updateDestination.do",
        this.destinationAddressForm
      ).then((res) => {
        let oData = res.data;
        if (oData.code === 0) {
          this.listDialogVisible = false;
          this.editDialogVisible = false;
          this.setDestinationAddressForm();
        } else if (oData.code != 401) {
          let tips = "<i class='el-icon-warn-tip'></i>" + oData.msg;
          this.$confirm(tips, "提示", {
            confirmButtonText: "好的",
            customClass: "confirmClass-style",
            iconClass: "",
            confirmButtonClass: "confirm",
            dangerouslyUseHTMLString: true,
            showCancelButton: false,
          });
        }
      });
    },
    // 设置任务收货地址
    setDestinationAddressForm() {
      this.taskForm.destination_company = this.destinationAddressForm.destination_company;
      this.taskForm.destination_name = this.destinationAddressForm.destination_name;
      this.taskForm.destination_phone = this.destinationAddressForm.destination_phone;
      this.taskForm.destination_address = this.destinationAddressForm.destination_address;

      this.$refs.taskForm.validateField("destination_company");
      this.$refs.taskForm.validateField("destination_name");
      this.$refs.taskForm.validateField("destination_phone");
      this.$refs.taskForm.validateField("destination_address");
    },
    choosePriority(priority, ifNotValid) {
      if (this.isDetail && !this.inWaitPickUp) {
      } else {
        this.taskForm.priority = priority;
        if (1 === priority) {
          this.minimum = minimum;
          this.secondary = secondaryUnchecked;
          this.highest = highestUnchecked;
        } else if (2 === priority) {
          this.minimum = minimumUnchecked;
          this.secondary = secondary;
          this.highest = highestUnchecked;
        } else if (3 === priority) {
          this.minimum = minimumUnchecked;
          this.secondary = secondaryUnchecked;
          this.highest = highest;
        } else {
          this.minimum = minimumUnchecked;
          this.secondary = secondaryUnchecked;
          this.highest = highestUnchecked;
        }
        if (!ifNotValid) {
          this.$refs.taskForm.validateField("priority");
        }
      }
    },
    getUsers(type, roleName, departmentId) {
      this.postJsonRequest(
        "/user-server/api/u-user/queryByDepartmentIdAndRoleName",
        {
          roleName,
          departmentId,
          removed: 0,
        }
      ).then((res) => {
        let oData = res.data;
        if (oData.code == 0) {
          if (type === 1) {
            this.users = oData.data;
          } else if (type === 2) {
            this.usersOfApprove = oData.data;
          }
        } else if (oData.code != 401) {
          let tips = "<i class='el-icon-warn-tip'></i>啊哦,用户获取失败~";
          this.$confirm(tips, "提示", {
            confirmButtonText: "好的",
            customClass: "confirmClass-style",
            iconClass: "",
            confirmButtonClass: "confirm",
            dangerouslyUseHTMLString: true,
            showCancelButton: false,
          });
        }
      });
    },
    changeUser(id) {
      if (id) {
        let user = {};
        user = this.users.find((item) => {
          return item.id === id;
        });
        if (user) {
          this.taskForm.receiverPhone = user.phone;
        } else {
          this.taskForm.receiverPhone = "";
        }
      } else {
        this.taskForm.receiverPhone = "";
      }
    },
    getStations() {
      this.getRequest(
        "/basic-info-server/station/getStationGroupByArea.do"
      ).then((res) => {
        let oData = res.data;
        if (0 === oData.code) {
          let data = oData.data;

          if (!this.isEmptyArray(data)) {
            this.stations = this.resetStation(data);
          } else {
            this.stations = [];
          }
        } else if (oData.code != 401) {
          let tips = "<i class='el-icon-warn-tip'></i>啊哦,获取战区失败~";
          this.$confirm(tips, "提示", {
            confirmButtonText: "好的",
            customClass: "confirmClass-style",
            iconClass: "",
            confirmButtonClass: "confirm",
            dangerouslyUseHTMLString: true,
            showCancelButton: false,
          });
        }
      });
    },
    resetStation(data) {
      if (!this.isEmptyArray(data)) {
        data.forEach((element) => {
          if (!this.isEmptyArray(element.children)) {
            element.children.forEach((e) => {
              e.id = e.id;
              e.value = e.name;
            });
          }
        });
      }
      return data;
    },
    handleChange(selectInfo) {
      if (selectInfo) {
        this.taskForm.name = selectInfo[1];
      }
    },
    //历史地址 发货地址发货战区修改
    handleAddressChange(selectInfo) {
      if (selectInfo && selectInfo.length > 1) {
        this.customerAddressForm.area_id = selectInfo[0];
        this.customerAddressForm.station_id = selectInfo[1];
      } else {
        this.customerAddressForm.area_id = "";
        this.customerAddressForm.station_id = "";
      }
    },
    // 发货件数修改
    handleGoodsNumChange(val) {
      let old = this.goodsNum;
      let difference = old - val;
      if (difference > 0) {
        this.handleDeleteGoods(difference);
      } else if (difference < 0) {
        difference = Math.abs(difference);
        for (let i = 0; i < difference; i++) {
          this.handleAddGoods();
        }
      }
      this.goodsNum = val;
      this.$nextTick(() => {
        this.countTotalWeight();
      });
    },
    handleAddGoods() {
      if (undefined == this.goodsList) {
        this.goodsList = new Array();
      }
      let obj = {};
      obj.local_id = "";
      obj.mission_id = this.taskForm.id;
      obj.goods_length = "";
      obj.goods_width = "";
      obj.goods_height = "";
      obj.goods_volume = "";
      obj.goods_weight = "";
      obj.goods_attribute_id = "";
      obj.goods_type_id = "";
      obj.goods_package_id = "";
      obj.goods_secrecy_id = "";
      obj.goods_inflammable_id = 0;
      obj.goods_attribute_id = 0;
      obj.goods_explosible_id = 0;
      obj.goods_cautery_id = 0;
      obj.attribute = [];

      this.goodsList.push(obj);
    },
    handleDeleteGoods(difference) {
      let len = this.goodsList.length;
      if (len > 0) {
        for (
          let index = len - 1, j = 0;
          index >= 0 && j < difference;
          index--, j++
        ) {
          this.goodsList.splice(index, 1);
        }
      }
    },
    handleSelectionChange(selection) {
      this.multipleSelection = selection;
    },
    countTotalWeight() {
      let goodsList = this.goodsList;
      if (goodsList.length > 0) {
        let goodsWeight = 0;
        let numReg = /^[0-9]*$/;
        let numRe = new RegExp(numReg);
        for (let i = 0, len = goodsList.length; i < len; i++) {
          let goods_weight = goodsList[i].goods_weight;
          if (!numRe.test(goods_weight)) {
            goods_weight = 0;
          }
          goodsWeight += goods_weight;
        }
        this.goodsTotalWeight = goodsWeight;
      } else {
        this.goodsTotalWeight = 0;
      }
    },
    initCascaderStyle() {
      let scrollbars = document.getElementsByClassName("el-scrollbar");
      if (scrollbars && scrollbars.length > 0) {
        for (let i = 0, len = scrollbars.length; i < len; i++) {
          scrollbars[i].style.background = "rgb(28, 35, 64)";
          scrollbars[i].style.border = "1px solid rgb(20, 107, 249)";
          scrollbars[i].style.boxShadow = "rgba(0, 0, 0, 0.41) 0px 3px 9px 0px";
          scrollbars[i].style.borderRadius = "3px";
        }
      }
    },
    // 获取货物类别
    getGoodsTypeList() {
      this.getRequest("/uav-task-server/goodstype/getGoodsTypeList.do").then(
        (res) => {
          let oData = res.data;
          if (oData.code == 0) {
            this.goodsTypes = oData.data;
          } else if (oData.code != 401) {
            let tips = "<i class='el-icon-warn-tip'></i>啊哦,货物类别获取失败~";
            this.$confirm(tips, "提示", {
              confirmButtonText: "好的",
              customClass: "confirmClass-style",
              iconClass: "",
              confirmButtonClass: "confirm",
              dangerouslyUseHTMLString: true,
              showCancelButton: false,
            });
          }
        }
      );
    },
    // 获取货物包装
    getGoodsPackageList() {
      this.getRequest(
        "/uav-task-server/goodpackage/getGoodsPackageList.do"
      ).then((res) => {
        let oData = res.data;
        if (oData.code == 0) {
          this.goodsPackages = oData.data;
        } else if (oData.code != 401) {
          let tips = "<i class='el-icon-warn-tip'></i>啊哦,货物包装获取失败~";
          this.$confirm(tips, "提示", {
            confirmButtonText: "好的",
            customClass: "confirmClass-style",
            iconClass: "",
            confirmButtonClass: "confirm",
            dangerouslyUseHTMLString: true,
            showCancelButton: false,
          });
        }
      });
    },
    // 查询任务
    queryTask() {
      const params = this.getQueryParam(this.queryTaskForm);
      this.getRequest(
        "/uav-task-server/mission/getMissionList.do?" + params
      ).then((res) => {
        let oData = res.data;
        if (oData.code == 0) {
          let data = oData.data;
          if (data) {
            this.taskList = data.list;
          }
        } else if (oData.code != 401) {
          let tips = "<i class='el-icon-warn-tip'></i>啊哦,任务列表获取失败~";
          this.$confirm(tips, "提示", {
            confirmButtonText: "好的",
            customClass: "confirmClass-style",
            iconClass: "",
            confirmButtonClass: "confirm",
            dangerouslyUseHTMLString: true,
            showCancelButton: false,
          });
        }
      });
    },
    // 点击任务列表
    clickTaskRow(row) {
      this.openedId = row.id;
      this.addTask = false;
      this.$refs.taskList.toggleRowSelection(row);
      this.initCascaderStyle();
      // this.getStations();
      this.getUsers(1, this.roleName, this.userInfo.departmentId);
      this.queryDepartment();
      this.getGoodsTypeList();
      this.getGoodsPackageList();
      if (undefined !== row.priority) {
        this.choosePriority(Number(row.priority), true);
      }
      this.formClass = "formTaskDetail";
      if (row.mission_status === 5 || row.mission_status === 8) {
        if (this.delPermission) {
          this.topHeight = "height: 720px;";
          this.formHeight = "height: 528px;";
        } else {
          this.topHeight = "height: 778px;";
          this.formHeight = "height: 584px;";
        }
      } else {
        if (this.copyPermission) {
          this.topHeight = "height: 720px;";
          this.formHeight = "height: 528px;";
        } else {
          this.topHeight = "height: 778px;";
          this.formHeight = "height: 584px;";
        }
      }

      this.isDetail = true;
      this.clickButton = true;
      if (row.mission_status === 5 || row.mission_status === 8) {
        this.inWaitPickUp = true;
        this.isHistory = false;
        this.rightTopDiv = "rightTopDiv";
        this.goodsListHeight = 281;
      } else {
        this.inWaitPickUp = false;
        this.isHistory = true;
        this.rightTopDiv = "rightTopDisableDiv";
        this.goodsListHeight = 338;
      }
      this.$nextTick(() => {
        this.getMissionById(row.id);
        this.$refs.taskForm.clearValidate();
        this.$refs.goodsList.clearValidate();
      });
    },
    // 获取任务详情
    getMissionById(id) {
      this.postJsonRequest("/uav-task-server/mission/getMissionById.do", {
        id,
      }).then((res) => {
        let oData = res.data;
        if (oData.code === 0) {
          this.taskForm = oData.data;

          let note = this.taskForm.note;
          if (note) {
            let notes = note.split(this.replaceStr);
            if (notes && notes.length > 0) {
              let notee = [];
              notes.forEach((item) => {
                if (item) {
                  notee.push(item);
                }
              });
              this.taskForm.historyNote = notee;
            } else {
              this.taskForm.historyNote = "";
            }
          } else {
            this.taskForm.historyNote = "";
          }
          this.$set(this.taskForm, "note", "");

          this.dealDataAfterGetDetail();
          let approve_user_department_id = this.taskForm
            .approve_user_department_id;
          if (approve_user_department_id) {
            this.getUsers(
              2,
              this.roleNameOfApprove,
              approve_user_department_id
            );
          }
          let area_id = this.taskForm.area_id;
          let station_id = this.taskForm.station_id;
          this.setStationAndArea(area_id, station_id);
          this.createCode(this.taskForm.local_id);
        } else if (oData.code != 401) {
          let tips = "<i class='el-icon-warn-tip'></i>" + oData.msg;
          this.$confirm(tips, "提示", {
            confirmButtonText: "好的",
            customClass: "confirmClass-style",
            iconClass: "",
            confirmButtonClass: "confirm",
            dangerouslyUseHTMLString: true,
            showCancelButton: false,
          });
        }
      });
    },
    // 生成条形码
    createCode(localId) {
      JsBarcode("#barCode", localId, {
        format: "CODE39", //条形码的格式
        lineColor: "#ffffff", //线条颜色
        width: 1, //线宽
        height: 25, //条码高度
        displayValue: true, //是否在条形码下方显示文字
        background: "transparent", //背景色
        font: "ArialMT", //设置文本的字体
        textMargin: 5, //设置条形码和文本之间的间距
        fontSize: "12", //设置文本的大小
        margin: 10, //设置条形码周围的空白边距
      });
    },
    // 获取详情后 数据处理
    dealDataAfterGetDetail() {
      let needTakeDelivery = this.taskForm.need_take_delivery;
      if (needTakeDelivery && 1 === Number(needTakeDelivery)) {
        this.$set(this.taskForm, "needTakeDelivery", true);
      } else {
        this.$set(this.taskForm, "needTakeDelivery", false);
      }
      this.changePickUp();
      // 设置货物列表信息 start
      let goodsList = this.taskForm.goods;
      if (goodsList && goodsList.length > 0) {
        let _this = this;
        _this.goodsForm.goodsName = goodsList[0].goods_name;
        let attributes = _this.attributes;
        goodsList.forEach(function (goods, index) {
          let attribute = [];
          let goods_attribute_id = goods.goods_attribute_id;
          if (goods_attribute_id && 1 === Number(goods_attribute_id)) {
            attribute.push(attributes[0]);
          }
          let goods_explosible_id = goods.goods_explosible_id;
          if (goods_explosible_id && 1 === Number(goods_explosible_id)) {
            attribute.push(attributes[1]);
          }
          let goods_inflammable_id = goods.goods_inflammable_id;
          if (goods_inflammable_id && 1 === Number(goods_inflammable_id)) {
            attribute.push(attributes[2]);
          }
          let goods_cautery_id = goods.goods_cautery_id;
          if (goods_cautery_id && 1 === Number(goods_cautery_id)) {
            attribute.push(attributes[3]);
          }
          _this.$set(goods, "attribute", attribute); //触发更新视图
        });
        _this.goodsList = goodsList;
        _this.goodsTotalNum = goodsList.length;
        _this.goodsNum = goodsList.length;
      } else {
        this.goodsList = [];
        this.goodsTotalNum = 0;
        this.goodsNum = 0;
      }
      this.$nextTick(() => {
        this.countTotalWeight();
      });
      // 设置货物列表信息 end
      // 设置指派货勤信息
      let users = this.users;
      if (users && users.length > 0) {
        let receiver_id = this.taskForm.receiver_id;
        if (receiver_id) {
          this.changeUser(receiver_id);
        }
      }
    },
    changeCellStyle(row, column, rowIndex, columnIndex) {
      if (row.column.label === "优先级") {
        return "color:#FFA63E;padding: 0;"; //修改的样式
      } else {
        return "color:#FFFFFF;padding: 0;";
      }
    },
    tableRowClassName({ row, rowIndex }) {
      if (this.openedId === row.id) {
        return "focusRowStyle";
      }
      return "rowStyle";
    },
    goodsListRowClassName({ row, rowIndex }) {
      row.index = rowIndex + 1;
      return "rowStyle";
    },
    // 添加任务按钮
    addClick() {
      this.inWaitPickUp = false;
      this.addTask = true;
      this.isHistory = false;
      this.isDetail = false;
      this.rightTopDiv = "rightTopDiv";
      this.goodsListHeight = 281;
      this.formClass = "form";
      this.clickButton = true;
      this.topHeight = "height: 720px;";
      this.formHeight = "height: 584px;";
      this.isHistory = false;
      this.restParams();
    },
    restParams() {
      // 重置表单内容
      this.ifNeedPickUpInfoShow = false;
      this.taskForm = {
        id: "",
        local_id: "0000000-0000",
        mission_name: "",
        priority: "",
        customer_company: "",
        customer_name: "",
        customer_phone: "",
        customer_address: "",
        area_id: "",
        station_id: "",
        station_name: "",

        destination_company: "",
        destination_name: "",
        destination_phone: "",
        destination_address: "",

        appointment_delivery_at: "",
        appointment_receive_at: "",
        needTakeDelivery: false,
        need_take_delivery: "0",

        receiver_id: "",
        receiverPhone: "",

        plan_receiver_at: "",
        mission_status: "",
        historyNote: "",
        note: "",
        user_id: "",
        created_at: "",
      };
      this.goodsList = [];
      this.goodsTotalNum = 0;
      this.goodsNum = 0;
      this.goodsTotalWeight = 0;
      this.goodsForm.goodsName = "";

      this.$nextTick(() => {
        this.initCascaderStyle();
        // this.getStations();
        this.getUsers(1, this.roleName, this.userInfo.departmentId);
        this.queryDepartment();
        this.getGoodsTypeList();
        this.getGoodsPackageList();
        this.choosePriority(null, true);
        this.$refs.taskForm.clearValidate();
        this.$refs.goodsList.clearValidate();
      });
    },
    setGoodsInfo() {
      let goodsName = this.goodsForm.goodsName;
      let goodsList = this.goodsList;
      if (goodsList && goodsList.length > 0) {
        goodsList.forEach(function (goods, index) {
          if (goodsName) {
            goods.goods_name = goodsName;
          }
          let attributes = goods.attribute;
          if (attributes.length > 0) {
            let goodsAttributeIndex = attributes.findIndex(
              (item) => item.id === "0"
            );
            if (goodsAttributeIndex === -1) {
              goods.goods_attribute_id = 0;
            } else {
              goods.goods_attribute_id = 1;
            }
            let goodsExplosibleIndex = attributes.findIndex(
              (item) => item.id === "1"
            );
            if (goodsExplosibleIndex === -1) {
              goods.goods_explosible_id = 0;
            } else {
              goods.goods_explosible_id = 1;
            }
            let goodsInflammableIndex = attributes.findIndex(
              (item) => item.id === "2"
            );
            if (goodsInflammableIndex === -1) {
              goods.goods_inflammable_id = 0;
            } else {
              goods.goods_inflammable_id = 1;
            }
            let goodsCauteryIndex = attributes.findIndex(
              (item) => item.id === "3"
            );
            if (goodsCauteryIndex === -1) {
              goods.goods_cautery_id = 0;
            } else {
              goods.goods_cautery_id = 1;
            }
          } else {
            goods.goods_attribute_id = 0;
            goods.goods_explosible_id = 0;
            goods.goods_inflammable_id = 0;
            goods.goods_cautery_id = 0;
          }
        });
      }
    },
    submit(formName) {
      let tips = "<i class='el-icon-warn-tip'></i>确定提交该任务?";
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "confirmClass-style",
        iconClass: "",
        confirmButtonClass: "confirm",
        dangerouslyUseHTMLString: true,
        cancelButtonClass: "cancel",
      })
        .then(() => {
          this.$refs[formName].validate(async (valid) => {
            if (valid) {
              let goodsList = "goodsList";
              this.$refs[goodsList].validate(async (valid) => {
                if (valid) {
                  const appointment_delivery_at = this.$moment(
                    this.taskForm.appointment_delivery_at
                  ).format("YYYY-MM-DD HH:mm:ss");
                  const appointment_receive_at = this.$moment(
                    this.taskForm.appointment_receive_at
                  ).format("YYYY-MM-DD HH:mm:ss");
                  let plan_receiver_at = "";
                  if (this.taskForm.plan_receiver_at) {
                    plan_receiver_at = this.$moment(
                      this.taskForm.plan_receiver_at
                    ).format("YYYY-MM-DD HH:mm:ss");
                  }
                  let needTakeDelivery = this.taskForm.needTakeDelivery;
                  if (needTakeDelivery) {
                    this.taskForm.need_take_delivery = "1";
                    let receiverId = this.taskForm.receiver_id;
                    if (!receiverId) {
                      let msg =
                        "<i class='el-icon-warn-tip'></i>需要取货时,指派货勤不能为空哦~";
                      this.$confirm(msg, "提示", {
                        confirmButtonText: "知道了",
                        customClass: "confirmClass-style",
                        iconClass: "",
                        confirmButtonClass: "confirm",
                        dangerouslyUseHTMLString: true,
                        showCancelButton: false,
                      });
                      return false;
                    }
                    if (!plan_receiver_at) {
                      let msg =
                        "<i class='el-icon-warn-tip'></i>需要取货时,取货时间不能为空哦~";
                      this.$confirm(msg, "提示", {
                        confirmButtonText: "知道了",
                        customClass: "confirmClass-style",
                        iconClass: "",
                        confirmButtonClass: "confirm",
                        dangerouslyUseHTMLString: true,
                        showCancelButton: false,
                      });
                      return false;
                    }
                  } else {
                    this.taskForm.need_take_delivery = "0";
                    plan_receiver_at = "";
                    this.taskForm.receiver_id = null;
                  }
                  this.setGoodsInfo();
                  let params = {
                    ...this.taskForm,
                    appointment_delivery_at,
                    appointment_receive_at,
                    plan_receiver_at,
                    goods: this.goodsList,
                  };
                  if (this.taskForm.id) {
                    this.updateMission(params);
                  } else {
                    this.addMission(params);
                  }
                }
              });
            }
          });
        })
        .catch((err) => {
        });
    },
    // 新增任务
    addMission(params) {
      this.postJsonRequest(
        "/uav-task-server/mission/addMission.do",
        params
      ).then((res) => {
        let oData = res.data;
        if (oData.code === 0) {
          this.getMissionStatisics();
          this.queryTask();
          this.openedId = null;
          this.clickButton = false;
          this.$message({
            message: "提交成功",
            duration: 1000,
            customClass: "message-s",
            iconClass: "el-icon-ok-tip",
            offset: 470,
            onClose: function () {},
          });
        } else if (oData.code != 401) {
          let tips = "<i class='el-icon-warn-tip'></i>" + oData.msg;
          this.$confirm(tips, "提示", {
            confirmButtonText: "好的",
            customClass: "confirmClass-style",
            iconClass: "",
            confirmButtonClass: "confirm",
            dangerouslyUseHTMLString: true,
            showCancelButton: false,
          });
        }
      });
    },
    // 修改任务
    updateMission(params) {
      this.postJsonRequest(
        "/uav-task-server/mission/updateMission.do",
        params
      ).then((res) => {
        let oData = res.data;
        if (oData.code === 0) {
          this.getMissionStatisics();
          this.queryTask();
          this.openedId = null;
          this.clickButton = false;
          this.$message({
            message: "操作成功",
            duration: 1000,
            customClass: "message-s",
            iconClass: "el-icon-ok-tip",
            offset: 470,
            onClose: function () {},
          });
        } else if (oData.code != 401) {
          let tips = "<i class='el-icon-warn-tip'></i>" + oData.msg;
          this.$confirm(tips, "提示", {
            confirmButtonText: "好的",
            customClass: "confirmClass-style",
            iconClass: "",
            confirmButtonClass: "confirm",
            dangerouslyUseHTMLString: true,
            showCancelButton: false,
          });
        }
      });
    },
    concelClick() {
      this.openedId = null;
      this.clickButton = false;
      this.goodsList = [];
      this.restParams();
    },
    deleteClick() {
      let tips = "<i class='el-icon-warn-tip'></i>确定删除该任务?";
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "confirmClass-style",
        iconClass: "",
        confirmButtonClass: "confirm",
        dangerouslyUseHTMLString: true,
        cancelButtonClass: "cancel",
      })
        .then(() => {
          let needTakeDelivery = this.taskForm.needTakeDelivery;
          if (needTakeDelivery) {
            this.taskForm.need_take_delivery = "1";
          } else {
            this.taskForm.need_take_delivery = "0";
          }
          let params = {
            ...this.taskForm,
            is_removed: 1,
          };
          this.updateMission(params);
          this.concelClick();
        })
        .catch((err) => {
        });
    },
    copyClick() {
      this.taskForm = {
        ...this.taskForm,
        id: "",
        local_id: "0000000-0000",
        historyNote: "",
        note: "",
        user_id: "",
        receiver_at: null,
      };
      let goodsList = this.goodsList;
      if (goodsList && goodsList.length > 0) {
        goodsList.forEach((goods) => {
          goods.id = "";
          goods.local_id = "";
        });
      }
      this.goodsList = goodsList;
      this.inWaitPickUp = false;
      this.isHistory = false;
      this.addTask = true;
      this.isDetail = false;
      this.rightTopDiv = "rightTopDiv";
      this.goodsListHeight = 281;
      this.topHeight = "height: 720px;";
      this.formHeight = "height: 584px;";

      this.formClass = "form";
      this.clickButton = true;
    },
    getButtonList(buttonList) {
      buttonList.forEach((button) => {
        this.getChildren(button);
      });
      if (this.addPermission) {
        this.contentHeight = " height: 395px";
        this.tableHeight = 325;
      } else {
        this.contentHeight = " height: 454px";
        this.tableHeight = 384;
      }
    },
    getChildren(item) {
      let menuId = item.id;
      let children = item.children;
      if (this.menuId === menuId) {
        for (let i = 0, len = children.length; i < len; i++) {
          let child = children[i];
          if (child) {
            if (child.path === "demandReport-add") {
              this.addPermission = child;
            } else if (child.path === "demandReport-copy") {
              this.copyPermission = child;
            } else if (child.path === "demandReport-edit") {
              this.editPermission = child;
            } else if (child.path === "demandReport-del") {
              this.delPermission = child;
            }
          }
        }
      } else {
        if (children) {
          children.forEach((child) => {
            this.getChildren(child);
          });
        }
      }
    },
  },
  watch: {
    goodsList: {
      handler(val) {
        this.goodsForm.goodsList = val;
      },
      deep: true,
    },
  },
  mounted() {
    this.addPermission = null;
    this.copyPermission = null;
    this.editPermission = null;
    this.delPermission = null;
    this.$emit("getMenuList", this.menuId, 1, 0, this.getButtonList);

    this.getMissionStatisics();
    this.$nextTick(function () {
      this.queryTask();
    });
    window.statisicsTimer = setInterval(this.getMissionStatisics, 28000); //28秒轮询一次
    window.queryTimer = setInterval(this.queryTask, 30000); //30秒轮询一次
  },
  beforeDestroy() {
    if (window.statisicsTimer) {
      clearInterval(window.statisicsTimer);
      window.statisicsTimer = null;
    }
    if (window.queryTimer) {
      clearInterval(window.queryTimer);
      window.queryTimer = null;
    }
  },
};
</script>
<style scoped>
@import "../../assets/css/home/DemandReport.css";
</style>
<style>
.sendAddressViewDialog .formAddress {
  margin-top: -22px;
  margin-left: 9px;
  height: 360px;
  overflow-x: hidden;
  overflow-y: auto;
}

.reciAddressViewDialog .formAddress {
  margin-top: -22px;
  margin-left: 9px;
  height: 310px;
  overflow-x: hidden;
  overflow-y: auto;
}

.formAddress .el-form-item {
  height: 32px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
}

.formAddress .el-form-item__label {
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTiM;
  font-weight: 400;
}

.formAddress .el-form-item__content {
  margin-left: -10px;
  width: 67%;
}

.formAddress .addressFormItem {
  margin-top: 0;
}
.addressIfDefaultFormItem {
  margin-top: 55px;
}
.addressIfDefaultFormItem .el-form-item__label {
  margin-left: -11px;
}

.addressIfDefaultFormItem .el-form-item__content {
  margin-left: -79px;
}

.addressIfDefaultFormItem .el-switch__core {
  width: 52px !important;
}
.formAddress .el-input__inner {
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTiM;
  font-weight: 400;
}
.formTaskDetail .el-form-item__error,
.form .el-form-item__error,
.formAddress .el-form-item__error,
.rightTopDiv .el-form-item__error {
  font-size: 12px;
  font-family: AlibabaPuHuiTiM;
  font-weight: 500;
  color: #f74347;
}
.formAddress .el-form-item__error {
  left: -30%;
}

.goodsList .el-form-item__error {
  position: unset;
}
.goodsList .el-select .el-input__inner {
  height: 24px;
  background-color: transparent !important;
  border: 1px solid #0083fd !important;
  color: rgba(255, 255, 255, 1) !important;
}
.goodsInfo .goodsName .el-form-item__label {
  margin-top: 10px;
  margin-bottom: -10px;
  font-size: 14px;
  font-family: AlibabaPuHuiTiR;
  font-weight: 400;
  color: #ffffff;
}
.rowAddress .el-select .el-input__inner {
  width: 246px;
  height: 32px;
  background: transparent !important;
  border: 1px solid #0083fd !important;
  color: rgba(255, 255, 255, 1) !important;
}
.goodsList .el-form-item,
.goodsList .el-form-item__content {
  width: 100px !important;
}

#demandReport .goodsList .cell.el-tooltip {
  display: flex;
}

#demandReport .goodsList .cell .el-form-item {
  margin-bottom: 0px;
}

.goodsList .cell.el-tooltip {
  flex-flow: row nowrap;
  justify-content: space-between;
}
.addressFormItem .el-textarea__inner {
  margin-left: 2px;
  width: 200px;
  height: 80px;
  background: rgba(255, 255, 255, 0.1) !important;
  color: rgba(255, 255, 255, 1) !important;
  border-radius: 3px;
  border: none;
  resize: none;
  font-size: 14px;
  font-family: AlibabaPuHuiTiM;
  font-weight: 400;
}

.addressFormItem .el-textarea__inner:active,
.addressFormItem .el-textarea__inner:focus {
  border: 1px solid #dadada !important;
}

/* span placeholder 样式 start*/
#demandReport span:empty:before {
  content: attr(placeholder);
  color: #cccccc;
}
#demandReport span:focus {
  content: none;
}
/* span placeholder 样式 end*/
</style>



// WEBPACK FOOTER //
// src/components/home/DemandReport.vue